import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import UnitFactory from "../../Entity/Factories/UnitFactory";
import SubscriptionFactory from "../../Entity/Factories/SubscriptionFactory";
import { SubscriptionInterface } from "../../Entity/Entities/Subscription/SubscriptionInterface";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ChargeTemplateInterface } from "../../Entity/Entities/Charge/ChargeTemplateInterface";
import Time from "../../Time/Time";
import Translator from "../../Translation/Translator";

export default function* unitCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_UNIT_CREATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_UNIT_CREATE_REQUEST
    });

    let chargeTemplatesFromPayload = action.payload?.unit?.chargeTemplates;

    if (action.payload?.unit.chargeTemplates){
      chargeTemplatesFromPayload = action.payload?.unit?.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        return {
          amount: chargeTemplate.amount,
          currencyId: chargeTemplate.currency,
          type: chargeTemplate.type,
          repeatPeriodId: chargeTemplate.repeatPeriod,
          description: chargeTemplate.description,
          paymentOffset: chargeTemplate.paymentOffset,
          dueDateFirstPayment: Time.formatOrNull(chargeTemplate.dueDateFirstPayment),
          firstDate: Time.formatOrNull(chargeTemplate.firstDate),
          endDate: Time.formatOrNull(chargeTemplate.endDate),
          isDefault: true,
          isPaidDirectlyToOwner: chargeTemplate.isPaidDirectlyToOwner,
          isCollective: chargeTemplate?.isCollective
        };
      })
    }

    if (action.payload.unit) {
      action.payload.unit.chargeTemplates = chargeTemplatesFromPayload;
    }
    
    const res = yield call(Http.post, "units",  action.payload?.unit);
    const unit: UnitInterface = UnitFactory.create(res.data.unit);
    const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.subscription);

    yield put({
      type: Constants.GLOBAL_UNIT_CREATE_SUCCESS,
      payload: {
        unit: unit
      }
    });

    if (!action.payload?.hideSnackbar) {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          type: "success",
          message: Translator.trans("snackbar-message-unit-created-successfully")
        }
      });
    }

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
      payload: {
        subscription: subscription
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, unit);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_UNIT_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUnitCreate() {
  yield takeEvery(Constants.GLOBAL_UNIT_CREATE_START, unitCreate);
}
